import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CreateChancel, Input } from 'components';
import { FindLoad, FindSuccessItem, useModal } from 'utils';
import { httpRequestsOnSuccessActions, systemActions } from 'store';

export const CreateEditServiceType = ({ info, afterSuccess }) => {
    const dispatch = useDispatch();
    const ACTION_TYPE = !!info ? 'EDIT_SERVICE_BY_ID_GLOBAL' : 'CREATE_SERVICE_GLOBAL';
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const { close } = useModal();

    const {
        control,
        handleSubmit,
        reset,
    } = useForm({
        defaultValues: {
            name: '',
            displayCode: '',
            category: ''
        }
    });

    useEffect(() => {
        if (info) {
            reset({
                name: info.name || '',
                displayCode: info.displayCode || '',
                category: info.category || ''
            });
        }
    }, [info, reset]);

    useEffect(() => {
        if (!!success) {
            afterSuccess();
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            reset();
        }
    }, [success]);

    function handleSave(data) {
        if (info) {
            dispatch(systemActions.editServiceByIdGlobal(data, info.id));
        } else {
            dispatch(systemActions.createServiceGlobal(data));
        }
    }

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{info ? 'Edit Service Type' : 'Add Service Type'}</p>
            <form onSubmit={handleSubmit(handleSave)}>
                <div className="modal-body-wrapper">
                    <Input
                        name="name"
                        label="Service Name*"
                        variant="outlined"
                        control={control}
                        maxLength={50}
                        rules={{
                            required: 'Service name is required.',
                            maxLength: {
                                value: 50,
                                message: 'Max length is 50 characters.',
                            },
                        }}
                    />
                    <Input
                        name="displayCode"
                        label="Display Code*"
                        variant="outlined"
                        control={control}
                        maxLength={20}
                        rules={{
                            required: 'Display code is required.',
                            maxLength: {
                                value: 20,
                                message: 'Max length is 20 characters.',
                            },
                        }}
                    />
                    <Input
                        name="category"
                        label="Category*"
                        variant="outlined"
                        control={control}
                        maxLength={50}
                        rules={{
                            required: 'Category is required.',
                            maxLength: {
                                value: 50,
                                message: 'Max length is 50 characters.',
                            },
                        }}
                    />
                </div>

                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
